module.exports = __webpack_public_path__ + "static/media/newPartyActive.af320577.svg";